import React, { FC } from 'react';
import SvgIcon from './SvgIcon';

const TrashIcon: FC = () => {
    return (
        <SvgIcon viewBox="0 0 11 12" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.12305 3.24414H2.11422H10.0436" strokeWidth={1.3} strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M3.60102 3.24407V2.25289C3.60102 1.99002 3.70545 1.73791 3.89133 1.55203C4.07721 1.36615 4.32932 1.26172 4.5922 1.26172H6.57455C6.83743 1.26172 7.08954 1.36615 7.27542 1.55203C7.4613 1.73791 7.56573 1.99002 7.56573 2.25289V3.24407M9.05249 3.24407V10.1823C9.05249 10.4452 8.94806 10.6973 8.76218 10.8832C8.5763 11.0691 8.32419 11.1735 8.06131 11.1735H3.10543C2.84256 11.1735 2.59045 11.0691 2.40457 10.8832C2.21868 10.6973 2.11426 10.4452 2.11426 10.1823V3.24407H9.05249Z"
                strokeWidth={1.3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default TrashIcon;
